import * as _ from 'lodash-es';
import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {OnDestroyMixin} from '@w11k/ngx-componentdestroyed';
import {DxDataGridModule} from 'devextreme-angular';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import {userRolesGetAsKeyValue} from '../../../../../@shared/_referencesLists/userRoles/userRoles';


@Component({
    selector: 'app-user-client-roles-selector',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UserClientRolesSelectorComponent),
            multi: true,
        },
    ],
    templateUrl: './user-client-roles-selector.component.html',
    imports: [
        DxDataGridModule,
        MatButtonModule,
        TranslateModule
    ],
    styleUrls: ['./user-client-roles-selector.component.scss']
})
export class UserClientRolesSelectorComponent extends OnDestroyMixin implements OnInit, ControlValueAccessor, OnDestroy {

  private usersRoles = userRolesGetAsKeyValue();
  userRolesKeyValue = [];

  @Input() set defaultUserRoles(value: string[]) {
    if (!_.isEqual(value, this.userRolesSelected)) {
      console.log('default userRoles changed!', value);
      this.userRolesSelected = value;
    }
  }

  @Output()
  valueChange = new EventEmitter<string>();

  @Output()
  userRolesChanged = new EventEmitter<string[]>();


  userRolesSelected: string[] = [];

  defaultUserRolesSelected =
    [
      'SURVEY_MULTI',
      'SURVEY_IDEA', 'SURVEY_COMBAT', 'SURVEY_BENCHMARK', 'SURVEY_KANO', // <----- Pas sûr que ça serve encore ?
      'SURVEY_EXCEL_EXPORT',
      'BASIC_ACCOUNT',
      'SAAS_PUBLICATION',
      'SHORTCUT_TO_V2',
      'V2_DETAILED_RESPONSES',
      'V2_RESULT_DASHBOARD'];


  constructor(
    private translator: TranslateService,
  ) {

    super();

    this.userRolesKeyValue = Object.keys(this.usersRoles).map((key) => {
      return {
        role: key,
        description: this.usersRoles[key][translator.currentLang],
      };
    });

  }

  //
  //
  //
  private propagateChange = (_: any) => {
  }

  writeValue(obj: string): void {
    // this.userRolesSelected = obj;
    this.userRolesSelected = obj.split(',');
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }

  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  selectionChanged($event: any) {
    // console.log(this.userRolesSelected);
    this.propagateChange(this.userRolesSelected.join(','));
    this.valueChange.emit(this.userRolesSelected.join(','));
    this.userRolesChanged.emit(this.userRolesSelected);
  }

  assignDefaultAccess() {

    this.userRolesSelected = this.defaultUserRolesSelected;
    this.propagateChange(this.userRolesSelected.join(','));

  }
}
